import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import alarmReducer from 'components/Common/Alarm/alarmSlice';
import sidebarReducer from 'components/Common/Sidebar/sidebarSlice';
import homeReducer from 'components/Layout/homeSlice';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import analyticsReducer from 'features/Analysis/analysisSlice';
import inverterReducer from 'features/Inverter/inverterSlice';
import authReducer from 'features/Login/authSlice';
import plantReducer from 'features/Plant/plantSlice';
import gatewayReducer from 'features/User/components/GatewayInfo/gatewaySlice';
import ViewersReducer from 'features/User/components/Viewers/ViewerSlide';
import createSagaMiddleware from 'redux-saga';
import { history } from '../utils';
import rootSaga from './rootSaga';
const rootReducer = combineReducers({
  router: connectRouter(history),
  auth: authReducer,
  sidebarReducer: sidebarReducer,
  homeReducer: homeReducer,
  plantReducer: plantReducer,
  gatewayReducer: gatewayReducer,
  ViewersReducer: ViewersReducer,
  inverterReducer: inverterReducer,
  alarmReducer: alarmReducer,
  analyticsReducer: analyticsReducer,
});

const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware, routerMiddleware(history)),
});
sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
